import React from 'react'
import { useSetRecoilState } from 'recoil'
import { openModalState } from 'recoils/atoms'

import { Button } from 'components'
import { getLabel } from 'helpers/language'

interface Props {
  title: string
  description: string
  confirmText?: string
  cancelText?: string
  isLoading?: boolean
  onConfirm?: () => void
  onClose?: () => void
}

export const Confirmation: React.FC<Props> = ({
  title,
  description,
  confirmText = getLabel('common:ok.button'),
  cancelText = getLabel('common:cancel.button'),
  isLoading,
  onConfirm = () => {},
  onClose = () => {},
}: Props) => {
  const setIsOpenModal = useSetRecoilState(openModalState)

  const base = 'con-confirmation'

  const handleClose = () => {
    setIsOpenModal(false)
    onClose()
  }

  return (
    <div className={base}>
      <h1 className={`${base}__title`}>{title}</h1>
      <span className={`${base}__description`}>{description}</span>
      <div className={`${base}__btn-group`}>
        <Button
          variants='secondary'
          className={`${base}__confirm-btn`}
          onClick={handleClose}
        >
          {cancelText}
        </Button>
        <Button
          type='submit'
          variants='primary'
          className={`${base}__confirm-btn`}
          isLoading={isLoading}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </div>
    </div>
  )
}

export default Confirmation
